import { render, staticRenderFns } from "./PositionPerson.vue?vue&type=template&id=073dda23&"
import script from "./PositionPerson.vue?vue&type=script&lang=js&"
export * from "./PositionPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports